@if (src) {
  @if (srcsetString && sizesString) {
    <img
      [src]="src"
      [srcset]="srcsetString"
      [sizes]="sizesString"
      [alt]="alt"
      [title]="title"
      [class]="imageClass"
      (load)="onLoad.emit(true)"
    />
  } @else {
    <img
      [src]="src"
      [alt]="alt"
      [title]="title"
      [class]="imageClass"
      (load)="onLoad.emit(true)"
    />
  }
}
